import { Navigate, Outlet } from 'react-router-dom'

import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import navigateToNextOnboardingPageAction from '../../actions/navigateToNextOnboardingPageAction'
import DreamerTypePage from './DreamerTypePage'
import DreamExplorationPage from './DreamExplorationPage'
import DreamFeedbackPage from './DreamFeedbackPage'
import DreamFlavorPage from './DreamFlavorPage'
import DreamkeeperAvatarPage from './DreamkeeperAvatarPage'
import DreamMemoryPage from './DreamMemoryPage'
import DreamRecallStatsPage from './DreamRecallStatsPage'
import DreamSharingPage from './DreamSharingPage'
import DreamSoundtrackPage from './DreamSoundtrackPage'
import DreamThemesPage from './DreamThemesPage'
import GroundingInRealLifePage from './GroundingInRealLifePage'
import InnerGuidePage from './InnerGuidePage'
import SyncedPage from './SyncedPage.tsx'
import VibeTodayPage from './VibeTodayPage'
import ZodiacSignPage from './ZodiacSignPage'

// New psychological onboarding pages
import BlocksFeedbackPage from './BlocksFeedbackPage'
import CommitmentFeedbackPage from './CommitmentFeedbackPage'
import CommitmentLevelPage from './CommitmentLevelPage'
import DreamBlocksPage from './DreamBlocksPage'
import DreamGoalsPage from './DreamGoalsPage'
import DreamTimingPage from './DreamTimingPage'
import DreamWhyDeeperPage from './DreamWhyDeeperPage'
import EmotionalStatePage from './EmotionalStatePage'
import IdealDreamSelfPage from './IdealDreamSelfPage'
import MindfulMomentsPage from './MindfulMomentsPage'
import PastAttemptsPage from './PastAttemptsPage'
import SelfBeliefPage from './SelfBeliefPage'
import SleepQualityFeedbackPage from './SleepQualityFeedbackPage'
import SleepQualityPage from './SleepQualityPage'
import TransformationFeedbackPage from './TransformationFeedbackPage'

const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="dream-exploration" replace />,
        index: true,
      },

      // Phase 1: Initial motivation & exploration
      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamExplorationPage />,
        path: 'dream-exploration',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamGoalsPage />,
        path: 'dream-goals',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamWhyDeeperPage />,
        path: 'dream-why-deeper',
      },

      // Phase 2: Current state assessment
      {
        action: navigateToNextOnboardingPageAction,
        element: <VibeTodayPage />,
        path: 'vibe-today',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepQualityPage />,
        path: 'sleep-quality',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepQualityFeedbackPage />,
        path: 'sleep-quality-feedback',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamMemoryPage />,
        path: 'dream-memory',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamRecallStatsPage />,
        path: 'dream-recall-stats',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamTimingPage />,
        path: 'dream-timing',
      },

      // Phase 3: Past experience & obstacles
      {
        action: navigateToNextOnboardingPageAction,
        element: <PastAttemptsPage />,
        path: 'past-attempts',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamBlocksPage />,
        path: 'dream-blocks',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <BlocksFeedbackPage />,
        path: 'blocks-feedback',
      },

      // Phase 4: Dream personality
      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamerTypePage />,
        path: 'dreamer-type',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamFlavorPage />,
        path: 'dream-flavor',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamThemesPage />,
        path: 'dream-themes',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <EmotionalStatePage />,
        path: 'emotional-state',
      },

      // Phase 5: Self-awareness & mindfulness
      {
        action: navigateToNextOnboardingPageAction,
        element: <MindfulMomentsPage />,
        path: 'mindful-moments',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <GroundingInRealLifePage />,
        path: 'grounding-in-real-life',
      },

      // Phase 6: Future self visualization
      {
        action: navigateToNextOnboardingPageAction,
        element: <IdealDreamSelfPage />,
        path: 'ideal-dream-self',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <SelfBeliefPage />,
        path: 'self-belief',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <TransformationFeedbackPage />,
        path: 'transformation-feedback',
      },

      // Phase 7: Commitment
      {
        action: navigateToNextOnboardingPageAction,
        element: <CommitmentLevelPage />,
        path: 'commitment-level',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <CommitmentFeedbackPage />,
        path: 'commitment-feedback',
      },

      // Phase 8: Personalization preferences
      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamSoundtrackPage />,
        path: 'dream-soundtrack',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamkeeperAvatarPage />,
        path: 'dreamkeeper-avatar',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <ZodiacSignPage />,
        path: 'zodiac-sign',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamSharingPage />,
        path: 'dream-sharing',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <DreamFeedbackPage />,
        path: 'dream-feedback',
      },

      // Phase 9: Final personalization
      {
        action: navigateToNextOnboardingPageAction,
        element: <InnerGuidePage />,
        path: 'inner-guide',
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <SyncedPage />,
        path: 'synced',
      },
    ],
  },
]

export default onboardingRoutes
